<template>
	<div class="sky-switch">
		<itemSearch v-bind="$attrs">
			<el-switch v-model="val" v-bind="$attrs" @change="change"> </el-switch>
		</itemSearch>
	</div>
</template>
<script>
import itemSearch from '@/components/iglobalwin/formComponents/SkySuffix.vue';
export default {
	name: 'sky-switch',
	props: ['value', 'toolContent'],
	inheritAttrs: false,
	data() {
		return {
			val: this.value,
		};
	},
	methods: {
		change(val) {
			this.$emit('input', val);
		},
	},
	watch: {
		value(val) {
			this.val = val;
		},
	},
	components: { itemSearch },
};
</script>
<style scoped lang="scss">
.sky-switch {
	height: 40px;
	display: flex;
	align-items: center;
}
</style>
